import { graphql } from '@apollo/client/react/hoc'

import { LEGACYIDENTIFIER } from '../../../shared/paths'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ match }) => ({
  variables: {
    queryString: `fields.legacyIdentifier=${match.params[LEGACYIDENTIFIER]}`,
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({ data: { loading, error, stores } }) => {
  if (error) {
    return { storeTitle: null }
  } else if (loading) {
    return { loading }
  }
  try {
    return {
      storeTitle: stores[0].title,
    }
  } catch (e) {
    return { storeTitle: null }
  }
}

const withStoreTitle = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
  skip: ({ match }) => !match.params[LEGACYIDENTIFIER],
})

export default withStoreTitle
